import { useEffect } from "react";

import { FiltersContainer } from "../../filters/ui/FiltersContainer";

import { SocialChannel } from "./SocialChannel";
import { useSocialAlertsFilterStore } from "./useSocialAlertsFilterStore";

export const SocialAlertsFilters = () => {
    const reset = useSocialAlertsFilterStore((state) => state.reset);

    useEffect(() => reset, [reset]);

    return (
        <FiltersContainer>
            <SocialChannel />
        </FiltersContainer>
    );
};
